import { Chip, Stack, Typography } from '@mui/material';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { RefundStatus, StepStatus } from '@/models/subsidy/status';
import { DescriptionStep } from '@/packages/subsidy/pages/refund-request/components/step-wrapper';
import { useRefundRequest } from '@/packages/subsidy/pages/refund-request/context';
import { formatDate } from '@/utils/format-date';

interface DescriptionProps {
  statusMessage?: string;
  status: StepStatus | null;
  reason: string | null;
}

const Description = ({ statusMessage, status, reason }: DescriptionProps) => {
  const chipStatus =
    status !== StepStatus.Pending && status !== StepStatus.Success;
  const showReason = status !== StepStatus.Success && reason;

  return (
    <Stack spacing={2} alignItems="flex-start">
      {chipStatus ? (
        <Chip label={statusMessage || ''} color={status || 'default'} />
      ) : (
        <Typography>{statusMessage}</Typography>
      )}
      {showReason && <Typography>{reason}</Typography>}
    </Stack>
  );
};

export const ResourceApproval = () => {
  const { getStepState, refundStatus, resourceApproval, currentStep } =
    useRefundRequest();
  const { status, disabled } = getStepState(2);
  const { bootstrap } = useBootstrapData();

  const companyName = bootstrap?.info?.colaborador?.empresa?.empresa;

  const decisionDate = resourceApproval?.decided_at
    ? formatDate(resourceApproval.decided_at)
    : '';

  const messages: Partial<Record<RefundStatus, string>> = {
    [RefundStatus.ResourceApprovalApproved]: `Pedido aprovado em ${decisionDate}`,
    [RefundStatus.ResourceApprovalCanceled]: `Pedido cancelado em ${decisionDate}`,
    [RefundStatus.ResourceApprovalRejected]: `Pedido reprovado em ${decisionDate}`,
    [RefundStatus.ResourceApprovalNotApproved]: `Pedido reprovado em ${decisionDate}`,
    [RefundStatus.ResourceApprovalPendingApproval]: `Análise ${companyName} pendente`,
  };

  const showSuccessMessage = currentStep === 4 || currentStep === 5;
  const statusMessage = refundStatus
    ? showSuccessMessage
      ? messages[RefundStatus.ResourceApprovalApproved]
      : messages[refundStatus]
    : '';

  return (
    <DescriptionStep
      title="2. Análise do item"
      stepStatus={status}
      disabled={disabled}
      description={
        <Description
          status={status}
          statusMessage={statusMessage}
          reason={resourceApproval?.decision_comment || ''}
        />
      }
    />
  );
};
